(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["team-signup-form-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const watched = new WeakSet();
  const apply = section => {
    const host = section.querySelector('shopify-forms-embed');
    const root = host && host.shadowRoot;
    if (!root || root.getElementById('team-signup-layout')) return;
    const style = document.createElement('style');
    style.id = 'team-signup-layout';
    style.textContent = `
      [data-testid="app-router"] {display:block!important;width:100%;}
      #form-container-ref {width:100%;}
      #form-container-ref > section:first-child {display:block;}
      #form-container-ref section[role="dialog"] {max-width:100%;width:100%;height:auto;min-height:0;margin:0!important;box-sizing:border-box;}
      #form-container-ref section[role="dialog"] > div:last-child {padding:0;}
      form[data-testid="form"] {
        display:flex;flex-direction:column;gap:30px!important;padding:0!important;
        height:auto;min-height:0;position:relative;
      }
      form[data-testid="form"] > div:has(shop-lead-capture) {position:absolute;top:0;left:0;}
      form[data-testid="form"] > div:has(> input) {display:flex;flex-direction:column;}
      form[data-testid="form"] label {
        position:static!important;order:-1;display:block;width:auto;
        transform:none!important;top:auto!important;left:auto!important;
        margin:0 0 12px;padding:0;color:#111!important;
        font-size:16px;line-height:22px;font-weight:400;max-width:none;
      }
      form[data-testid="form"] input {
        display:block;box-sizing:border-box;width:100%;height:52px;
        padding:14px 16px!important;background:#f5f5f5;
        border:0;box-shadow:none;border-radius:7px;
        font-size:16px;line-height:24px;color:#111;
      }
      form[data-testid="form"] input:focus-visible {outline:none!important;outline-offset:0;box-shadow:inset 0 0 0 2px #205c43!important;}
      form[data-testid="form"] button[type="submit"] {
        width:auto;align-self:flex-start;box-sizing:border-box;
        min-height:52px;padding:14px 18px;margin:0;
        border:0;border-radius:7px;background:#205c43;color:#fff;
        font-size:16px;line-height:24px;font-weight:400;
      }
      @media(max-width:767px) {form[data-testid="form"]{gap:24px!important;}}
    `;
    root.append(style);
  };
  const scan = () => document.querySelectorAll('.sign-up, .team-signup-page').forEach(section => {
    apply(section);
    if (watched.has(section)) return;
    watched.add(section);
    const observer = new MutationObserver(() => apply(section));
    observer.observe(section, {childList:true, subtree:true});
    const timer = setInterval(() => {
      apply(section);
      if (section.querySelector('shopify-forms-embed')?.shadowRoot?.getElementById('team-signup-layout')) {
        clearInterval(timer);
      }
    }, 250);
    setTimeout(() => clearInterval(timer), 15000);
  });
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
  } catch(e) { console.error(e); }
})();

})();
